var map = {
	"./0.png": 8822,
	"./0_fd.png": 7605,
	"./0_stat.png": 3857,
	"./1.png": 6509,
	"./1_fd.png": 5014,
	"./1_stat.png": 8445,
	"./2.png": 3237,
	"./2_fd.png": 1118,
	"./2_stat.png": 858,
	"./3.png": 7867,
	"./3_fd.png": 780,
	"./3_stat.png": 6626,
	"./4.png": 5685,
	"./4_fd.png": 268,
	"./4_stat.png": 2942,
	"./5.png": 976,
	"./5_fd.png": 6884,
	"./5_stat.png": 3471,
	"./6.png": 4450,
	"./6_fd.png": 1553,
	"./6_stat.png": 3708,
	"./7.png": 368,
	"./7_fd.png": 3576,
	"./7_stat.png": 1594
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2320;